import React from 'react';
import { Stack, Text, ControlLink } from '@moda/om';

export const SiteFooterMobileContact: React.FC = () => (
  <Stack space={3} alignItems="flex-start">
    <Stack space={5} direction="horizontal">
      <Stack space={1}>
        <Text color="cement">Monday - Friday</Text>
        <Text color="cement">Saturday</Text>
      </Stack>
      <Stack space={1}>
        <Text color="cement">8am-8pm EST</Text>
        <Text color="cement">9am-6pm EST</Text>
      </Stack>
    </Stack>
    <Text>
      <Text color="cement">Toll Free (US): </Text>
      <ControlLink href="tel:+18007079898" underlined={false}>
        +1 800-707-9898
      </ControlLink>
    </Text>
    <Text>
      <Text color="cement">International: </Text>
      <ControlLink href="tel:+12127290984" underlined={false}>
        +1 212-729-0984
      </ControlLink>
    </Text>
  </Stack>
);
